/**
 * Safely parse unknown to object record.
 */
export function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' ? value as Record<string, unknown> : null;
}

/**
 * Safely parse unknown to array of object records.
 */
export function asRecordArray(value: unknown): Record<string, unknown>[] {
  return Array.isArray(value)
    ? value.filter((item): item is Record<string, unknown> => Boolean(item) && typeof item === 'object')
    : [];
}

/**
 * Safely extract string from record.
 */
export function extractString(record: Record<string, unknown> | null, ...keys: string[]): string | null {
  if (!record) return null;
  for (const key of keys) {
    if (typeof record[key] === 'string' && record[key]) {
      return record[key] as string;
    }
  }
  return null;
}

/**
 * Normalize an unknown thrown value to a log-friendly message.
 */
export function getErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}

/**
 * Safely extract ISO date string from record.
 */
export function extractDate(record: Record<string, unknown> | null, ...keys: string[]): string | null {
  const value = extractString(record, ...keys);
  if (!value) return null;
  
  // Validate ISO date format
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  
  return value;
}
